export const en = {
    details: 'Details',
    passengers_count: {
        one: 'Cost for {count} passenger',
        some: 'Cost for {count} passengers',
        many: 'Cost for {count} passengers',

    },
};
